<app-dropdown [closeMethod]="closeMethod">
  <div class="user-dropdown">
    <a class="user-main-settings" [routerLink]="['/user', user.id]">
      <img [src]="user.avatar_url" alt="user_avatar" class="avatar" />
      <div class="username">{{ user.display_name }}</div>
    </a>
    <div class="user-additional-settings">
      <div class="setting">
        <div class="label">
          {{ "dropdown-user.label.email" | translate }}
        </div>
        <div>{{ user.email }}</div>
      </div>
      <div class="setting">
        <div class="label">
          {{ "dropdown-user.label.company" | translate }}
        </div>
        <div>{{ user.company_name }}</div>
      </div>
      <div class="setting">
        <div class="label">
          {{ "dropdown-user.label.timezone" | translate }}
        </div>
        <div>{{ user.timezone.name }}</div>
      </div>
      <div class="setting">
        <div class="label">
          {{ "dropdown-user.label.language" | translate }}
        </div>
        <div>{{ user.language.name }}</div>
      </div>
      <div
        class="setting"
        *ngIf="hasPerm(AppFeatures.COMPANY_MANAGER_COMPANY_OBJECTS_TREE)"
      >
        <div class="label">
          {{ "dropdown-user.label.view-all-company-objects" | translate }}
        </div>
        <sui-switch
          [checked]="user.list_company_objects"
          (click)="toggleCompanyObjectsView($event)"
          (checkedChange)="handleCompanyObjectsToggle($event)"
        ></sui-switch>
      </div>
      <div class="setting">
        <div class="label">
          {{ "dropdown-user.label.language" | translate }}
        </div>
        <app-language-picker></app-language-picker>
      </div>
    </div>
    <div class="actions">
      <sui-button
        size="sm"
        variant="primary"
        [leadingIcon]="['fas', 'cog']"
        (click)="onUserSettings()"
      >
        {{ "dropdown-user.button.user-settings" | translate }}
      </sui-button>
      <sui-button
        size="sm"
        variant="primary"
        [leadingIcon]="['fas', 'key']"
        (click)="onChangePassword()"
      >
        {{ "dropdown-user.button.change-password" | translate }}
      </sui-button>
    </div>
    <div class="logout">
      <sui-button
        size="sm"
        variant="warning"
        [leadingIcon]="['fas', 'sign-out-alt']"
        (click)="onLogout()"
      >
        {{ "dropdown-user.button.log-out" | translate }}
      </sui-button>
    </div>
  </div>
</app-dropdown>
